export default __webpack_public_path__ + "static/media/BlueTreeCute1.ec50e4cb.jpg";